var _rect, _rect2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWindowsIconLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 101,
    viewBox: "0 0 101 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 100,
    height: 100,
    rx: 50,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_14_984",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 20,
    width: 61,
    height: 61
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20.75,
    y: 20.75,
    width: 59.5,
    height: 59.5,
    fill: "#D9D9D9",
    stroke: "#F2F8FC",
    strokeWidth: 0.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_14_984)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.3962 74.6035L41.3956 74.6029C40.965 74.1738 40.7491 73.6452 40.7491 73C40.7491 72.3548 40.965 71.8262 41.3956 71.3971L41.3962 71.3965C41.8253 70.9659 42.3539 70.75 42.9991 70.75H45.4991H45.7491V70.5V65.5V65.25H45.4991H30.4991C29.1909 65.25 28.0777 64.7875 27.1459 63.8557C26.2124 62.9222 25.7491 61.8081 25.7491 60.5V33C25.7491 31.6919 26.2124 30.5778 27.1459 29.6443C28.0777 28.7125 29.1909 28.25 30.4991 28.25H70.4991C71.8074 28.25 72.9215 28.7125 73.855 29.6444C74.7867 30.5779 75.2491 31.6919 75.2491 33V60.5C75.2491 61.8082 74.7866 62.9223 73.8548 63.8557C72.9214 64.7875 71.8073 65.25 70.4991 65.25H55.4991H55.2491V65.5V70.5V70.75H55.4991H57.9991C58.6444 70.75 59.1739 70.9659 59.6048 71.3968C60.0339 71.8258 60.2491 72.3545 60.2491 73C60.2491 73.6455 60.0339 74.1742 59.6048 74.6032C59.1739 75.0341 58.6444 75.25 57.9991 75.25H42.9991C42.3539 75.25 41.8253 75.0341 41.3962 74.6035ZM30.2491 60.5V60.75H30.4991H70.4991H70.7491V60.5V33V32.75H70.4991H30.4991H30.2491V33V60.5Z",
    fill: "#0A78CD",
    stroke: "#F2F8FC",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindowsIconLarge);
export default __webpack_public_path__ + "static/media/windowsIconLarge.55887b1a46074b873e349d33863f6775.svg";
export { ForwardRef as ReactComponent };